import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'db-link-renderer',
  templateUrl: './link-renderer.component.html',
  styleUrls: ['./link-renderer.component.scss']
})
export class LinkRendererComponent implements ICellRendererAngularComp {
  public params: any;

  constructor(private router: Router) { }

  agInit(params: any): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  navigateLink() {
    if (this.params.inRouterLink) {
      this.router.navigate([this.params.inRouterLink, this.params.value]);
    } else if (this.params.useParamsValue) {
      window.open(this.params.value, '_blank');
    } else {
      this.router.navigate(['/page-not-found']);
    }
  }
}
